import { h, JSX } from "preact";

import RawColor from "../../../foundation/api/model/colors/RawColor";
import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./ColorDot.module.css";

type NativeButtonProps = JSX.HTMLAttributes<HTMLButtonElement>;

interface Props extends NativeButtonProps {
    style?: CSSProperties;
    color?: string;
    rgbaColor?: RawColor;
    size?: number;
    selected?: boolean;
    withBorder?: boolean;
}

function ColorDot({
    class: cssClass,
    style,
    color,
    rgbaColor,
    size,
    selected = false,
    withBorder = false,
    ...nativeButtonProps
}: Props) {
    const colorDotStyle: CSSProperties = style ?? {};

    if (color) {
        colorDotStyle["--color-dot-bg-color"] = color;
    }

    if (rgbaColor) {
        colorDotStyle["--color-dot-bg-color"] = `rgba(${rgbaColor.r}, ${rgbaColor.g}, ${rgbaColor.b}, ${rgbaColor.a})`;
    }

    if (size) {
        colorDotStyle["--color-dot-size"] = `${size}px`;
    }

    return (
        <button
            {...nativeButtonProps}
            class={classname(styles.colorDot, cssClass, {
                [styles.selected]: selected,
                [styles.withBorder]: withBorder
            })}
            style={colorDotStyle}>
        </button>
    );
}

export default ColorDot;
